import _ from 'lodash';

/**
 * Returns whether a LE (Libreta de Enrolamiento) is valid.
 */
function isLE (value) {
    return !_.isString(value) || value.length < 6 || value.length > 7;
}

export default isLE;
